"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(_ref) {
  var trigger = _ref.trigger,
      maximumSearch = _ref.maximumSearch,
      _ref$matchOnlyTrigger = _ref.matchOnlyTrigger,
      matchOnlyTrigger = _ref$matchOnlyTrigger === void 0 ? false : _ref$matchOnlyTrigger;
  var startRange = matchOnlyTrigger ? 0 : 1;
  return new RegExp("(\\B" + trigger + "[\\S]{" + startRange + "," + maximumSearch + "}([\\s]?([\\S]{" + startRange + "," + maximumSearch + "})?)?)$");
};

exports.default = _default;
module.exports = exports.default;